<template>
    <CardPage :section="17" :page="4" next="/" nextLabel="Finish" :nextFunction="finish" :audio="true">
        <p>
            Not easy stuff to cover, but you don’t play! You earned another sticker for this category!
        </p>
        <ResponsiveImage :src="sticker.image" :alt="sticker.text"></ResponsiveImage>
    </CardPage>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        sticker: get('section17/sticker')
    },
    methods: {
        finish() {
            this.$store.set('section17/complete', true);
            this.$store.set('section17/sticker@earned', true);
        }
    }
};
</script>
